import * as Phaser from 'phaser';

/**
 * Exposes the Phaser namespace as the global `Phaser`.
 *
 * Several game systems use the global `Phaser.*` (for example
 * `Phaser.Math.Distance.Between`) without importing it, and their tests stub
 * that global. Up to 4.0.0-rc.7, Vite resolved `phaser` to the UMD build,
 * which sets `window.Phaser`. Since 4.0.0 the package has an `exports` map that
 * sends bundlers to the ESM build, which does not, so this module sets it.
 *
 * main.tsx and GameScene import this first, before any system that uses the global.
 */
const globalScope = globalThis as { Phaser?: unknown };
globalScope.Phaser ??= Phaser;
